// extracted by mini-css-extract-plugin
export default {"container":"ImageViewer_container__BTtLs","zoomButtons":"ImageViewer_zoomButtons__fkAXu","zoomSlider":"ImageViewer_zoomSlider__MWRWI"};